import yup from '../../../../../translations/yup/yupLocale';

const validationSchema = yup.object({
  company: yup.string().required(),
  name: yup.string().min(3).required().label('Name'),
});

export default validationSchema;
